<template lang="">
  <div class="cardContent1">
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="chart" ref="circleChart"></div>
  </div>
</template>

<script>
import { getIndustrialDistribution } from "@/api/cyzl";
import { loadCircleChart } from "../chart/circleChart";
import { timerMixin } from "@/util/mixin/timerMixin";
import { get } from "@/api/index";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["面积", "主要品种"],
      typeDatas: [[], []],
      active: 0
    };
  },
  mounted() {
    this.circleChart = this.$echarts.init(this.$refs.circleChart);
    // window.addEventListener("resize", () => {
    //   this.circleChart.resize();
    // });
    this.getdatas();
    // this.initChart();
    this.startTimer();
  },
  methods: {
    getdatas() {
      getIndustrialDistribution().then(res => {
        if (res.data) {
          if (res.data.maominData) {
            let circleData = [];
            res.data.maominData.forEach(ele => {
              circleData.push({
                name: ele.name,
                value: Number(ele.area)
              });
              // mmClList.push({
              //   name: ele.name,
              //   value: Number(ele.cl)
              // });
            });
            console.log("circleData ==", circleData);
            this.typeDatas[0] = circleData;
            this.initChart();
          }
        }
      });
      get("/api/restful/zzjd/getPlantingScaleRanking", {
        type: "品种"
      }).then(res => {
        let data = res.data;
        let circleData = [];
        data.map(item => {
          circleData.push({
            name: item.dataKindName,
            value: item.sum
          });
        });
        this.typeDatas[1] = circleData;
      });
    },
    initChart() {
      const fontSizes = 13;
      const widths = 10;
      const itemGaps = 6;
      console.log("this.av", this.active);
      if (this.active === 0) {
        // 各区种植面积占比,  静态
        // circleData = [
        //   {
        //     name: "高州市",
        //     value: 55.81
        //   },
        //   {
        //     name: "电白区",
        //     value: 36.04
        //   },
        //   {
        //     name: "化州市",
        //     value: 24.81
        //   },
        //   {
        //     name: "信宜市",
        //     value: 13.6
        //   },

        //   {
        //     name: "茂南区",
        //     value: 5.26
        //   }
        // ];
        loadCircleChart(
          this.circleChart,
          this.typeDatas[this.active],
          fontSizes,
          widths,
          itemGaps,
          "center",
          "面积占比"
        );
      } else {
        loadCircleChart(
          this.circleChart,
          this.typeDatas[this.active],
          fontSizes,
          widths,
          itemGaps,
          "bottom",
          "主要品种"
        );
      }
    },
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.initChart();
      if (clearT) {
        this.startTimer();
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cardContent1
  height 100%
  position relative
  .tab-box
    position absolute
    top 0px
    left 50%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
  .chart
    height 100%
</style>
